import { computed, getCurrentInstance } from 'vue'
import { useStore } from 'vuex'
import workflowApi from '@/api/workflowApi'
import safeStructuredClone from '@/utils/clone'
import usePrompts from '@/composables/usePrompts'
import { workflowHelpers } from '@/mixins/workflowHelpers'

const useGenerateEntity = () => {
  const store = useStore()
  const { proxy } = getCurrentInstance()
  const workflow = computed(() => store.state.workflow.workflow)

  const { getSingleEntity } = usePrompts()

  const generateEntity = async ({ eventId, name, description }) => {
    let newEntities

    if (!workflow.value.aiDescription) {
      store.commit('snackbar/showMessage', {
        content: 'Please enter a description in settings: Get help from AI to build your workflow',
        timeout: 6000,
        color: 'red',
        location: 'center center'
      }, { root: true })
      return
    }

    proxy.$loadingState.start()

    const res = await getSingleEntity(eventId, name, description)

    if (!res?.entity) {
      store.commit('snackbar/showMessage', {
        content: 'The AI was unable to create an entity. Please try adjusting the description.',
        timeout: 6000,
        color: 'red',
        location: 'center center'
      }, { root: true })

      proxy.$loadingState.stop()
      return
    }

    const entityTable = workflowHelpers.methods.convertLLMResponseToEntity(res.entity)
    const entityExists = (workflow.value.dataModels ?? []).some((item) => item.name === entityTable.name)

    if (entityTable && !entityExists) {
      newEntities = [...safeStructuredClone(workflow.value.dataModels ?? []), entityTable]
    }

    if (newEntities) {
      await workflowApi.updateDataModels({
        dataModelsOnWorkflow: newEntities?.length > 0 ? newEntities : undefined,
        workflow: workflow.value
      })
    }

    proxy.$loadingState.stop()

    return entityTable
  }

  return { generateEntity }
}

export default useGenerateEntity
